// Find a role object in roleOptions by its numeric value
export function findRoleByValue(roleOptions, value) {
  if (!Array.isArray(roleOptions)) return undefined;
  return roleOptions.find((r) => r.value === Number(value));
}

/**
 * Build filter data object from URL search params
 * @param {Object} params - Parsed URL search params
 * @param {Array} roleOptions - Available role options
 * @returns {Object} Filter data object for the form
 */
export function buildFilterFromParams(params, roleOptions) {
  const filterData = {};

  if (params.name) {
    filterData.name = params.name;
  }

  if (params.email) {
    filterData.email = params.email;
  }

  if (params.role && roleOptions.length > 0) {
    const roleValues = params.role.split(",");
    const matchedRoles = roleValues
      .map((value) => findRoleByValue(roleOptions, value))
      .filter(Boolean);
    if (matchedRoles.length > 0) {
      filterData.role = matchedRoles;
    }
  }

  if (params.pageSize) {
    filterData.pageSize = Number(params.pageSize);
  }

  return filterData;
}

// Clean and normalize the user filter object, attaching range and sort info
export function cleanUserFilter(filter, userRange, userSort) {
  const filtered = {};

  // Text fields
  if (filter.name) filtered.name = filter.name;
  if (filter.email) filtered.email = filter.email;

  // Multi select - serialize to comma-separated values
  if (Array.isArray(filter.role) && filter.role.length > 0) {
    filtered.role = filter.role.map((item) => item?.value ?? item).join(",");
  }

  // Pagination
  filtered.userRange = userRange;
  filtered.userSort = userSort;
  if (filter.pageSize) filtered.pageSize = filter.pageSize;

  return filtered;
}
